import { useEffect, useState } from 'react';
import { fetchReleases, splitByChannel, type ReleasesDoc, type ReleaseEntry } from '../api/downloadsApi';

export interface UseReleasesResult {
  loading: boolean;
  doc: ReleasesDoc;
  stable: ReleaseEntry | null;
  experimental: ReleaseEntry | null;
}

export function useReleases(): UseReleasesResult {
  const [loading, setLoading] = useState(true);
  const [doc, setDoc] = useState<ReleasesDoc>({ updatedAt: null, releases: [] });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const next = await fetchReleases();
      if (!cancelled) {
        setDoc(next);
        setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const { stable, experimental } = splitByChannel(doc);
  return { loading, doc, stable, experimental };
}
